module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.crumbs
    }
  }), _vm._v(" "), _c('flash-message'), _vm._v(" "), _c('div', {
    staticClass: "ls-board-box"
  }, [_c('div', {
    staticClass: "row ls-box-group"
  }, [_c('div', {
    staticClass: "col-sm-3 col-lg-3"
  }, [_c('div', {
    staticClass: "ls-box"
  }, [_c('div', {
    staticClass: "ls-box-head"
  }, [_c('h6', {
    staticClass: "ls-title-4"
  }, [_vm._v(_vm._s(_vm.$t('taxes.attributes.id')))])]), _vm._v(" "), _c('div', {
    staticClass: "ls-box-body",
    attrs: {
      "data-test": "tax.id"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.tax.id))])]), _vm._v(" "), _c('div', {
    staticClass: "ls-box-footer"
  }, [_c('small', [_c('div', {
    attrs: {
      "data-test": "tax.created"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('taxes.show.since', {
        date: _vm.date.parseDate(_vm.tax.created_at)
      }))
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-lg-3"
  }, [_c('div', {
    staticClass: "ls-box"
  }, [_c('div', {
    staticClass: "ls-box-head"
  }, [_c('h6', {
    staticClass: "ls-title-4"
  }, [_vm._v(_vm._s(_vm.$t('taxes.show.tax_status')))])]), _vm._v(" "), _c('div', {
    staticClass: "ls-box-body",
    attrs: {
      "data-test": "tax.status"
    }
  }, [(_vm.tax.active) ? _c('strong', [_vm._v(_vm._s(_vm.$t('taxes.attributes.active')))]) : _c('strong', [_vm._v(_vm._s(_vm.$t('taxes.attributes.inactive')))])]), _vm._v(" "), _c('div', {
    staticClass: "ls-box-footer"
  }, [(_vm.tax.active) ? _c('authorized-link', {
    attrs: {
      "tag": "update_tax"
    }
  }, [_c('button', {
    staticClass: "ls-btn",
    class: {
      'ls-btn-danger': _vm.tax.active
    },
    on: {
      "click": function($event) {
        _vm.inactivateTax()
      }
    },
    model: {
      value: (_vm.tax.active),
      callback: function($$v) {
        _vm.tax.active = $$v
      },
      expression: "tax.active"
    }
  }, [_vm._v(_vm._s(_vm.$t('application.button.inactive')))])]) : _c('authorized-link', {
    attrs: {
      "tag": "update_tax"
    }
  }, [_c('button', {
    staticClass: "ls-btn",
    class: {
      'ls-btn-primary': _vm.tax.active
    },
    on: {
      "click": function($event) {
        _vm.activateTax()
      }
    },
    model: {
      value: (_vm.tax.active),
      callback: function($$v) {
        _vm.tax.active = $$v
      },
      expression: "tax.active"
    }
  }, [_vm._v(_vm._s(_vm.$t('application.button.active')))])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-lg-3"
  }, [_c('div', {
    staticClass: "ls-box"
  }, [_c('div', {
    staticClass: "ls-box-head"
  }, [_c('h6', {
    staticClass: "ls-title-4"
  }, [_vm._v(_vm._s(_vm.$t('taxes.show.active_in_contract')))])]), _vm._v(" "), _c('div', {
    staticClass: "ls-box-body"
  }, [_c('strong', [_vm._v(_vm._s(_vm.tax.quantity_contracts_applied))])]), _vm._v(" "), _c('div', {
    staticClass: "ls-box-footer"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ls-box"
  }, [_c('div', {
    staticClass: "ls-float-left"
  }, [_c('h4', {
    staticClass: "ls-title-4"
  }, [_vm._v(_vm._s(_vm.$t('taxes.show.details')))])]), _vm._v(" "), _c('div', {
    staticClass: "ls-float-right"
  }, [(_vm.tax.active) ? _c('authorized-link', {
    attrs: {
      "tag": "update_tax"
    }
  }, [_c('router-link', {
    staticClass: "ls-btn-primary ls-no-margin",
    attrs: {
      "to": {
        name: 'edit_tax',
        params: {
          id: _vm.tax.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ls-sm-margin-rigth"
  }, [_vm._v(_vm._s(_vm.$t('application.button.edit')))])])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "ls-clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "ls-label col-md-6 col-lg-8"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('taxes.show.tax_name')))]), _vm._v(" "), _c('p', {
    attrs: {
      "name": "tax.name"
    }
  }, [_vm._v(_vm._s(_vm.tax.name))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-md-6 col-lg-8"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('taxes.show.tax_value')))]), _vm._v(" "), _c('p', {
    attrs: {
      "name": "tax.value"
    }
  }, [_vm._v(_vm._s(_vm.tax.value) + "%")])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-md-6 col-lg-8"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('taxes.show.tax_scope')))]), _vm._v(" "), _c('p', {
    attrs: {
      "name": "tax.scope"
    }
  }, [_vm._v(_vm._s(_vm.tax.scope))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 ls-display-flex justify-content-flex-end ls-no-padding"
  }, [_c('router-link', {
    staticClass: "ls-btn",
    attrs: {
      "to": {
        name: 'taxes'
      },
      "title": _vm.$t('application.menu.taxes'),
      "role": "menuitem"
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('application.button.back')))])])], 1), _vm._v(" "), _c('modal-inactive', {
    model: {
      value: (_vm.inactiveObjects),
      callback: function($$v) {
        _vm.inactiveObjects = $$v
      },
      expression: "inactiveObjects"
    }
  }), _vm._v(" "), _c('modal-activate', {
    model: {
      value: (_vm.activateObjects),
      callback: function($$v) {
        _vm.activateObjects = $$v
      },
      expression: "activateObjects"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b580925"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/taxes/Show.vue
// module id = 723
// module chunks = 1